var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
export var Checkbox = React.forwardRef(function (props, ref) {
    var label = props.label, helpText = props.helpText, checkboxProps = props.checkboxProps;
    return (React.createElement("div", { className: "flex items-start" },
        React.createElement("div", { className: "flex items-center h-5" },
            React.createElement("input", __assign({ ref: ref }, checkboxProps, { type: "checkbox", className: "focus:ring-gold-500 h-4 w-4 text-gold border-gray-300 rounded" }))),
        React.createElement("div", { className: "ml-3 text-sm" },
            label && (React.createElement("label", { htmlFor: checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.id, className: "font-medium text-gray-700" }, label)),
            helpText && React.createElement("p", { className: "text-gray-500" }, helpText))));
});
Checkbox.displayName = "Checkbox";
//# sourceMappingURL=Checkbox.js.map